import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { merge, Subscription } from 'rxjs';
import { AuthenticationService } from '../../../services/authentication.service';
import { TemplateService } from '../../../services/template.service';
import { UserService } from '../../../services/user.service';
import { PASSWORD_VALIDATORS } from '../../../../../../projects/client/src/app/shared/validators/password-policy';
import { fadeAnimation, sidepaneMove } from '../../../shared/animations/sidepane-animation';
import { Router } from '@angular/router';
import { ToastService } from '../../../../../../projects/client/src/app/shared/services';

@Component({
  selector: 'hf-change-password',
  templateUrl: 'hf-change-password.component.html',
  styleUrls: ['hf-change-password.component.scss', '../../../styles/components/sidepanes.partial.scss'],
  animations: [sidepaneMove, fadeAnimation],
  host: { '[@sidepaneMove]': 'true' }
})
export class ChangePasswordComponent implements OnInit, OnDestroy {
  public changePassFG: UntypedFormGroup;
  private _passwordsUpdatedSub: Subscription;

  public notValidPassword: string;
  public email: string;
  public submitted: boolean;
  public serverError = false;
  public serverMessage: string;

  constructor(
    private router: Router,
    private templateService: TemplateService,
    private fb: UntypedFormBuilder,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private toasterService: ToastService
  ) {
    this.changePassFG = this.fb.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', PASSWORD_VALIDATORS],
      newPasswordRep: ['', Validators.required],
      newPasswordNotValid: ['', Validators.required]
    });

    this.email = this.userService.getUser().email;
  }

  ngOnInit() {
    const passwordsUpdated = merge(
      this.changePassFG.get('newPassword').valueChanges,
      this.changePassFG.get('newPasswordRep').valueChanges
    );

    this._passwordsUpdatedSub = passwordsUpdated.subscribe(() => {
      if (this.changePassFG.get('newPassword').value != this.changePassFG.get('newPasswordRep').value) {
        this.changePassFG.get('newPasswordNotValid').setErrors({ passwordsDontMatch: true });
      } else {
        this.changePassFG.get('newPasswordNotValid').setErrors(null);
      }
    });
  }

  onBack() {
    const url = this.router.routerState.snapshot.url;
    const before = url.replace('(settings:password)', '');
    this.router.navigateByUrl(before);
  }

  ngOnDestroy() {
    this._passwordsUpdatedSub.unsubscribe();
  }

  public onSubmit() {
    this.submitted = true;
    this.serverError = false;
    this.authenticationService
      .changePassword(this.changePassFG.value)
      .then(() => {
        this.toasterService.add({ header: `Password Changed` }, 'success');
        this.onBack();
      })
      .catch((err) => {
        this.submitted = false;

        const message = err?.error?.error?.message ?? 'Something went wrong. Please try again.';

        // 409 -> current password incorrect
        // 400 -> new password failed policy (or other validation)
        if (err?.status === 409) {
          this.notValidPassword = this.changePassFG.get('currentPassword').value;
          return;
        }

        this.serverError = true;
        this.serverMessage = message;
        this.changePassFG.get('newPassword').setErrors({ serverInvalid: true }, { emitEvent: false });
      });
  }
}
